import { BehaviorSubject, Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs";

const loading = new BehaviorSubject(false);

/**
 *
 * @param observer {function}
 * @return {Subscription}
 */
export function loadingChanges(observer = () => {
}) {
  return loading.pipe(distinctUntilChanged())
    .subscribe(observer);
}

export function startLoading() {
  loading.next(true);
}

export function stopLoading() {
  loading.next(false);
}